export const SCHEDULE_REGISTRATION_TAB_LIST = [
  {
    label: '수업',
    value: 'LECTURE'
  },
  {
    label: '기타 일정',
    value: 'PERSONAL'
  }
];
